<section>
  <div class="container-style">
    <form novalidate [formGroup]="formRejectQuotation" class="mb-2 py-1 px-2">
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-12 mb-1">
          <app-custom-autocomplete formControlName="conceptIdConceptRejection" [labelText]="'Concepto'"
            [list]="listRejectConcepts" [required]="true" (onChangeSelect)="getRejectConcept($event)">
          </app-custom-autocomplete>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-12 mb-1">
          <app-custom-textarea formControlName="observationRejection" [labelText]="'Observación'"
            [required]="true"></app-custom-textarea>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-2 col-12 d-flex justify-content-end mt-3">
          <app-custom-button [label]="'Rechazar'" [severity]="'danger'" [variant]="undefined" [width]="'5rem'"
            (onClick)="rejectQuotation()"></app-custom-button>
        </div>
      </div>
    </form>
  </div>
</section>